import type { Dispatch, RefObject, SetStateAction } from "react";
import type { SearchFilters } from "./types";

export function useSearchPagination({
  setFilters,
  totalPages,
  resultsTopRef,
}: {
  setFilters: Dispatch<SetStateAction<SearchFilters>>;
  totalPages: number | undefined;
  resultsTopRef: RefObject<HTMLDivElement | null>;
}) {
  const setPage = (nextPage: number) => {
    const normalized = Math.max(
      1,
      Math.min(nextPage, totalPages || nextPage)
    );

    setFilters((prev) => ({
      ...prev,
      page: normalized,
    }));

    window.requestAnimationFrame(() => {
      const el = resultsTopRef.current;
      if (!el) return;
      window.scrollTo({
        top: 0,
        behavior: "smooth",
      });
    });
  };

  return { setPage };
}
